import * as React from 'react';
import Icon from '@ant-design/icons/lib/components/Icon';
const ControlCloseCircle = React.memo((props) => (<Icon component={() => (<svg focusable="false" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
        <g>
          <path d="M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zm0 1a6 6 0 1 0 0 12A6 6 0 0 0 8 2z"/>
          <path d="M5.525 4.818 8 7.293l2.475-2.475a.5.5 0 0 1 .638-.058l.069.058a.5.5 0 0 1 0 .707L8.707 8l2.475 2.475a.5.5 0 1 1-.707.707L8 8.707l-2.475 2.475a.5.5 0 0 1-.638.058l-.069-.058a.5.5 0 0 1 0-.707L7.293 8 4.818 5.525a.5.5 0 0 1 .707-.707z"/>
        </g>
      </svg>)} {...props}/>));
export default ControlCloseCircle;
